import fire from '../conf/initFirebase';
import {SnackBarActions} from "./snackbar.actions";

export const AuthenticateActions = Object.freeze({
    SIGNIN: 'authenticate/SIGNIN',
    SIGNIN_SUCCESS: 'authenticate/SIGNIN_SUCCESS',
    SIGNIN_FAILURE: 'authenticate/SIGNIN_FAILURE',
    LOGOUT: 'authenticate/LOGOUT',
    LOGOUT_SUCCESS: 'authenticate/LOGOUT_SUCCESS',
    LOGOUT_FAILURE: 'authenticate/LOGOUT_FAILURE',
    LOGIN: 'authenticate/LOGIN',
    LOGIN_SUCCESS: 'authenticate/LOGIN_SUCCESS',
    LOGIN_FAILURE: 'authenticate/LOGIN_FAILURE',

    signin: (values, callback) => dispatch => {
        dispatch({type: AuthenticateActions.SIGNIN});

        setTimeout(() => {
            fire.auth().createUserWithEmailAndPassword(values['email'], values['password']).catch(error => {
                console.log(`Oops, an error occured => Code: ${error.code}. Message: ${error.message}`);
                return dispatch({type: AuthenticateActions.SIGNIN_FAILURE});
            });
            dispatch({type: AuthenticateActions.SIGNIN_SUCCESS});
            dispatch(SnackBarActions.displayMessage('Inscription effectuée avec succès, vous êtes maintenant connecté'));
            return callback();
        }, 2000);
    },

    login : (values, callback) => dispatch => {
        dispatch({type: AuthenticateActions.LOGIN});
        setTimeout(() => {
            fire.auth().signInWithEmailAndPassword(values['email'], values['password']).catch(error => {
                console.log(`Oops, an error occured => Code: ${error.code}. Message: ${error.message}`);
                return dispatch({type: AuthenticateActions.LOGIN_FAILURE})
            });
            dispatch({type: AuthenticateActions.LOGIN_SUCCESS});
            dispatch(SnackBarActions.displayMessage('Connexion effectuée avec succès'));
            return callback();
        }, 2000);
    },

    logout: () => dispatch => {
        dispatch({type: AuthenticateActions.LOGOUT});

        fire.auth().signOut().then(() => {
            dispatch(SnackBarActions.displayMessage("Déconnexion effectuée avec succès"));
            return dispatch({type: AuthenticateActions.LOGOUT_SUCCESS});
        }).catch(error => {
            console.log('error => ', error);
            return dispatch({type: AuthenticateActions.LOGOUT_FAILURE});
        })
    }
});


// WEBPACK FOOTER //
// ./src/actions/authenticate.actions.js